import type { ExtractedField } from "../../types"
import { PAYMENT_TERMS_OPTIONS } from "../../fieldConstants"
import { EditableSelectField } from "./EditableSelectField"

interface PaymentTermsFieldProps {
  field: ExtractedField
  editableFieldAttr: Record<string, string>
  focusTargetAttr: Record<string, string>
  onSelectChange: (field: ExtractedField, value: string) => void
  disabled?: boolean
}

export const PaymentTermsField = ({
  field,
  editableFieldAttr,
  focusTargetAttr,
  onSelectChange,
  disabled
}: PaymentTermsFieldProps): JSX.Element => {
  // Always pass a string (never undefined) so the Radix Select stays
  // controlled across empty/non-empty transitions. See resolveSelectValue.
  const isKnownValue = PAYMENT_TERMS_OPTIONS.some((option) => option.value === field.field_value)
  const selectValue = isKnownValue ? field.field_value ?? "" : ""

  return (
    <EditableSelectField
      value={selectValue}
      placeholder="Select payment method"
      options={PAYMENT_TERMS_OPTIONS}
      onChange={(value) => onSelectChange(field, value)}
      editableFieldAttr={editableFieldAttr}
      focusTargetAttr={focusTargetAttr}
      disabled={disabled}
    />
  )
}
